import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Projects </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={"https://i.imgur.com/Qs8rcMD.png"}
              title="Chat App"
              description="Created public / private group chat application to hold real-time conversations to bring the users closer into one centralized channel."
              stack="React.js, CSS, Framer Motion, Node.js, Express.js, Socket.io"
              sourceCode="https://github.com/prinzuchoudhury/lets-chat"
              liveDemo="https://sharp-jepsen-f7426f.netlify.app/"
              disabled1=""
              disabled2=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={"https://i.imgur.com/nd4QCxH.png"}
              title="Virtual Trial Room"
              description="Implemented a real-time marker-less AR system using the Kinect Sensor that portrays an augmented view of the user in a dynamic real-time live video mode with virtual superimposed clothes."
              stack="Augmented Reality, Unity 3D, Vuforia AR SDK, Scannet software"
              sourceCode=""
              liveDemo="https://www.youtube.com/watch?v=wReojI63mww"
              disabled1="-disabled"
              disabled2=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={"https://i.imgur.com/1xTTL0a.png"}
              title="Weather PWA App"
              description="Provides real time weather conditions according to a specific place. Used latest web features to bring native-like capabilities and reliability,"
              stack="Javascript, CSS, React.js, Axios"
              sourceCode="https://github.com/prinzuchoudhury/Weather-PWA"
              liveDemo="https://mystifying-villani-212602.netlify.app/"
              disabled1=""
              disabled2=""
            />
          </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={"https://i.imgur.com/BzMBhzN.png"}
              title="Watchlist"
              description="Created a form with inputs to store watchful movies and their descriptions. Uses reducers and local storage for better usage."
              stack="Javascript, CSS, React.js, Context API"
              sourceCode="https://github.com/prinzuchoudhury/BingeWatchList"
              liveDemo="https://elegant-kare-62805d.netlify.app"
              disabled1=""
              disabled2=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={"https://i.imgur.com/RupwSJQ.png"}
              title="User Authentication System"
              description="A Node.js user authentication system made with bcrypt"
              stack="Node.js, Express,js, bcrypt"
              sourceCode="https://github.com/prinzuchoudhury/User-Auth"
              liveDemo=""
              disabled1=""
              disabled2="-disabled"
            />
          </Col>

          

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={"https://i.imgur.com/1a2fpNL.png"}
              title="Pizza Website"
              description="A pizza-order website made using React.js and animated with Framer Motion."
              stack="Javascript, CSS, React.js, Framer Motion"
              sourceCode="https://github.com/prinzuchoudhury/Pizza-Site"
              liveDemo="https://angry-leavitt-b1e238.netlify.app"
              disabled1=""
              disabled2=""
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
